import {CUSTOM_ELEMENTS_SCHEMA, NgModule, Type} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {OrderConfirmationOrderInfoComponent} from './order-confirmation-order-info/order-confirmation-order-info.component';
import {OrderConfirmationBuyerEmailComponent} from './order-confirmation-buyer-email/order-confirmation-buyer-email.component';
import {OrderConfirmationListItemComponent} from './order-confirmation-list-item/order-confirmation-list-item.component';

import {BundleProvidedByModule} from '../bundle-provided-by/bundle-provided-by.module';

import {OrderTableModule} from '../order-table/order-table.module';

import {DcpDateFormatter} from '@dcp/configurator';

const orderConfirmationComponents: Array<Type<any>> = [
  OrderConfirmationBuyerEmailComponent,
  OrderConfirmationOrderInfoComponent,
  OrderConfirmationListItemComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OrderConfirmationBuyerEmailComponent: {
          component: OrderConfirmationBuyerEmailComponent,
        },
        OrderConfirmationOrderInfoComponent: {
          component: OrderConfirmationOrderInfoComponent,
        },
        OrderConfirmationListItemComponent: {
          component: OrderConfirmationListItemComponent,
        },
      },
    }),
    I18nModule,
    DcpDateFormatter,
    BundleProvidedByModule,
    OrderTableModule,
    ...orderConfirmationComponents,
  ],
  providers: [],
  exports: [...orderConfirmationComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpOrderConfirmationModule {}
